import React from "react";
import { useQuery } from "react-query";
import { ordersData } from "../globalApi/Api";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";

const OrderInvoice = () => {
  const { state } = useLocation();
  const detailsCompany = localStorage.getItem("companyDetails");
  const companyDetails = detailsCompany ? JSON.parse(detailsCompany) : null;

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "ordersData",
    ordersData,
    {
      refetchOnWindowFocus: false,
    }
  );

  let details = (data && data?.data) || [];

  // Determine selected date (use provided salesDate or default to today)
  const selectedDateStr = state?.salesDate || new Date().toISOString().split("T")[0];

  // Return all matching entries (filter by executive and sales date)
  let matchingOrders = details.filter((item) => {
    if (!item?.salesDate) return false;
    const orderDateStr = new Date(item.salesDate).toISOString().split("T")[0];
    return (
      item?.executiveName === state?.executiveName && orderDateStr === selectedDateStr
    );
  });

  // Download Functionality
  const handleDownload = () => {
    const element = document.getElementById("invoicePage");
    const opt = {
      margin: 0.5,
      filename: `Order-Route-Wise.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  console.log("state", state);
  // Records have already been filtered by the selected sales date above
  const selectedOrders = matchingOrders || [];

  return (
    <>
      <div className="invoce_main_block">
        <div className="invoice_sub_block">
          <div id="invoicePage">
            <div className="table-responsive invoice_table_block">
              {/* <table className="table">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      {companyDetails?.shopName || null}
                      <br />
                      {`${companyDetails?.companyAddress || ""} , ${
                        companyDetails?.companyLocation || ""
                      }`}
                      <br />
                      {`${companyDetails?.district || ""} ,${
                        companyDetails?.companyPincode || ""
                      }`}
                      <br />
                      {"TAMILNADU"}
                    </th>
                    <th
                      colSpan="2"
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      Executive : {state?.executiveName}
                      <br />
                      Route No : {state?.lineroute}
                      <br />
                    </th>
                  </tr>
                  <tr>
                    <th className="invoice_table_heading">Invoice No</th>
                    <th className="invoice_table_heading">Customer Name</th>
                    <th className="invoice_table_heading">Address</th>
                    <th className="invoice_table_heading">Phone No</th>
                    <th className="invoice_table_heading">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {matchingOrders && matchingOrders?.length > 0 ? (
                    <>
                      {matchingOrders?.map((item, i) => {
                        const totalAmount = item?.orderProducts?.reduce(
                          (sum, product) => {
                            const price =
                              (product?.price || 0) -
                              (product?.discountPrice || 0);
                            return sum + (product?.quantity || 0) * price;
                          },
                          0
                        );

                        return (
                          <tr key={i}>
                            <td className="invoice_table_data">
                              {item?.invoiceNo || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.customerName || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.customerAddress || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.contact || "-"}
                            </td>
                            <td className="invoice_table_data">
                              ₹{totalAmount.toLocaleString() || "0"}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td
                          colSpan="4"
                          style={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Grand Total
                        </td>
                        <td style={{ fontWeight: "bold", textAlign: "center" }}>
                          ₹
                          {matchingOrders
                            .reduce((acc, item) => {
                              const totalAmount = item?.orderProducts?.reduce(
                                (sum, product) => {
                                  const price =
                                    (product?.price || 0) -
                                    (product?.discountPrice || 0);
                                  return sum + (product?.quantity || 0) * price;
                                },
                                0
                              );
                              return acc + totalAmount;
                            }, 0)
                            .toLocaleString()}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        <h3>No Records Found</h3>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table> */}

              <table className="table">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      {companyDetails?.shopName || null}
                      <br />
                      {`${companyDetails?.companyAddress || ""} , ${
                        companyDetails?.companyLocation || ""
                      }`}
                      <br />
                      {`${companyDetails?.district || ""} ,${
                        companyDetails?.companyPincode || ""
                      }`}
                      <br />
                      {"TAMILNADU"}
                    </th>
                    <th
                      colSpan="3"
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      Executive : {state?.executiveName}
                      <br />
                      Sales Date : {selectedDateStr}
                      <br />
                    </th>
                  </tr>
                  <tr>
                    <th className="invoice_table_heading">Invoice No</th>
                    <th className="invoice_table_heading">Customer Name</th>
                    <th className="invoice_table_heading">Address</th>
                    <th className="invoice_table_heading">Phone No</th>
                    <th className="invoice_table_heading">Sales Date</th>
                    <th className="invoice_table_heading">Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedOrders && selectedOrders?.length > 0 ? (
                    <>
                      {selectedOrders?.map((item, i) => {
                        const totalAmount = item?.orderProducts?.reduce(
                          (sum, product) => {
                            const price =
                              (product?.price || 0) -
                              (product?.discountPrice || 0);
                            return sum + (product?.quantity || 0) * price;
                          },
                          0
                        );

                        const formattedDate = item?.salesDate
                          ? new Date(item?.salesDate).toLocaleDateString("en-GB")
                          : "-";

                        return (
                          <tr key={i}>
                            <td className="invoice_table_data">
                              {item?.invoiceNo || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.customerName || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.customerAddress || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {item?.contact || "-"}
                            </td>
                            <td className="invoice_table_data">
                              {formattedDate}
                            </td>
                            <td className="invoice_table_data">
                              ₹{totalAmount.toLocaleString() || "0"}
                            </td>
                          </tr>
                        );
                      })}

                      {/* ✅ Grand Total Row */}
                      <tr>
                        <td
                          colSpan="5"
                          style={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Grand Total
                        </td>
                        <td style={{ fontWeight: "bold", textAlign: "center" }}>
                          ₹
                          {selectedOrders
                            .reduce((acc, item) => {
                              const totalAmount = item?.orderProducts?.reduce(
                                (sum, product) => {
                                  const price =
                                    (product?.price || 0) -
                                    (product?.discountPrice || 0);
                                  return sum + (product?.quantity || 0) * price;
                                },
                                0
                              );
                              return acc + totalAmount;
                            }, 0)
                            .toLocaleString()}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        <h3>No Records Found</h3>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-lg-12">
            <button
              className="invoice_download_button"
              type="button"
              onClick={handleDownload}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderInvoice;
